export default __webpack_public_path__ + "static/media/Fuori.8e6c8308.avif";